import { useCallback, useEffect, useState } from 'react';
import { CensusService } from '../../services/census/censusService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage census status data fetching and transformation.
* ES: Hook para gestionar la obtención y transformación de datos del estado de censos.
----------------------------------------------------------------------------------------*/

const useCensusStatus = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999, 
        filter_filters: { ...initialFilters } 
    });

    const fetchCensusStatus = useCallback(async () => {
        try {
            const service = new CensusService();
            const response = await service.listForSelectStatus(filters);
            const fetchedData = response.getResponseData().data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; color: string; }) => ({
                    value: data.id,
                    label: data.name,
                    color: data.color,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching statuses:', error);
        }
    }, []);

    const updateCensusStatusHookFilters = (newFilters: any) => {
        setFilters((prevFilters : any) => ({ ...prevFilters, ...newFilters }));
    };

    useEffect(() => {
        fetchCensusStatus();
    }, [filters]);

    const getCensusStatusList = () => {
        return data;
    };

    return { fetchCensusStatus, getCensusStatusList, updateCensusStatusHookFilters };
}

export default useCensusStatus;